module.exports = __webpack_public_path__ + "static/media/truck-main-img.9aaf7967.jpg";